import { CREATE, DELETE, DELETE_MANY, GET_LIST, GET_MANY, GET_MANY_REFERENCE, GET_ONE, UPDATE, UPDATE_MANY } from "ra-core"

export const directVariables: { [key: string]: { [key: string]: string } } = {
    'merchant_docs': {
        'GET_MANY': 'merchant_docs',
    },
    'offers': {
        'UPDATE_MANY': "set_offer_status",
        'UPDATE': "set_offer_statuses",
    }
}


export const customBuildVariables = (introspectionResults: any) => (
    resource: any,
    aorFetchType: any,
    params: any,
    queryType: any
) => {
    switch (aorFetchType) {
        case GET_LIST:
            return params

        case GET_MANY_REFERENCE:
            return params
        case GET_MANY:
        case DELETE_MANY:
            return {
                ids: params.ids
            }

        case GET_ONE:
            return {
                id: params.id
            }
        case DELETE:
            return {
                id: params.id
            }
        case CREATE:
            return {
                data: params.data
            }

        case UPDATE:
            return {
                id: params.id,
                data: params.data,
            };

        case UPDATE_MANY:
            return {
                ids: params.id,
                data: params.data,
            };
    }
}


export default customBuildVariables